import Collection from '../../collection';
import CustomField from '../../model/refbooks/field';

export default Collection.extend( {
	endpoint: 'news/custom_fields',
	responseAt: 'custom_fields',
    model: CustomField
} );


// WEBPACK FOOTER //
// ./src/js/collection/refbooks/fields.js